<script setup>
import { useI18n } from 'vue-i18n';
import DatePicker from 'vue-datepicker-next';

defineProps({
  modelValue: { type: Date, default: null },
  hasError: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-1">
    <span class="mb-0.5 text-heading-3 text-n-slate-12">{{
      t('TASKS.CREATE.FIELDS.END_TIME')
    }}</span>
    <DatePicker
      :value="modelValue"
      type="time"
      format="HH:mm"
      :show-second="false"
      :placeholder="t('TASKS.CREATE.FIELDS.END_TIME_PLACEHOLDER')"
      input-class="mx-input"
      :append-to-body="false"
      @update:value="emit('update:modelValue', $event)"
    />
    <span v-if="hasError" class="text-xs text-n-ruby-9">
      {{
        modelValue
          ? t('TASKS.CREATE.FIELDS.END_TIME_ERROR')
          : t('TASKS.CREATE.FIELDS.END_TIME_REQUIRED')
      }}
    </span>
  </div>
</template>
